// 评估api
import request from '@/utils/request.js'
import qs from 'qs'

// 评估列表 + 搜索结果
export const assessmentList = (page, phone) => {
  return request({
    method: 'get',
    url: `/zzzx/list/${page}/${phone || ''}`,
  })
}

// 评估详情
export const assessmentListDetails = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/assessmentdetails/${id}`,
  })
}

// 评估对接
export const docked = (id) => {
  return request({
    method: 'post',
    url: '/zzzx/docked',
    data: qs.stringify({
      id
    })
  })
}

// 评估删除
export const delsteass = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/modifystatus/${id}`,
  })
}

// 评估修改进度
export const modifyAssessmentListDetails = (data) => {
  return request({
    method: 'post',
    url: '/zzzx/upfinanceorpro',
    data: qs.stringify(data)
  })
}

// 评估修改提交
export const assessmentListDetailsUp = (id, file_path) => {
  return request({
    method: 'post',
    url: `/zzzx/assessmentdetails/${id}`,
    data: qs.stringify({
      file_path
    })
  })
}
